import styled from "styled-components"

export const ModalWrapper = styled.div`
    .aen_overlay {
        display: block;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(1, 1, 1, 35%);
        z-index: 10;
        transition: all 0.3s linear;
    }
    .aen_container {
        position: fixed;
        top: 42px;
        width: 70vw;
        left: calc((100vw - 70vw) / 2);
        padding: 12px;
        border-radius: 4px;
        min-height: 200px;
        background-color: #fff;
        z-index: 20;
        transition: all 0.3s linear;
    }
    .aen_header {
        font-size: 1.4rem;
        text-align: center;
        border-bottom: 1px solid #e2c1c1;
        padding-bottom: 12px;
    }
    .aen_body {
        margin: 0;
        padding: 0;
        list-style: none;
        max-height: 70vh;
        overflow-y: scroll;
    }
    .aen_item {
        margin-bottom: 12px;
        &_image {
            width: 150px;
            height: 80px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 12px;
            img {
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 100%;
            }
        }
        &_input {
            label {
                display: block;
                font-weight: 500;
                color: #1c1c1c;
                margin-bottom: 8px;
            }
            input {
                padding: 0 12px;
                height: 35px;
                width: 100%;
                border: 1px solid #e2c1c1;
                border-radius: 4px;
                outline: none;
                color: #1c1c1c;
                &:focus {
                    border: 1px solid #1c1c1c;
                }
            }
            textarea {
                padding: 0 12px;
                max-width: 100%;
                min-width: 100%;
                min-height: 100px;
                max-height: 100px;
                border-radius: 4px;
                outline: none;
                color: #1c1c1c;
                &:focus {
                    border: 1px solid #1c1c1c;
                }
            }
            select {
                width: 100%;
                height: 35px;
                outline: none;
                border: 1px solid #e2c1c1;
                border-radius: 4px;
                background-color: #fff;
                &:focus {
                    border: 1px solid #1c1c1c;
                }
            }

            div.DraftEditor-root {
                height: 490px;
                width: auto;
                overflow-y: auto;
            }

            div.DraftEditor-editorContainer,
            div.public-DraftEditor-content {
                height: 100%;
            }
        }
        &_error {
            font-style: italic;
            color: #fb6e2e;
            margin: 0;
        }
    }
    .aen_footer {
        display: flex;
        justify-content: flex-end;
        margin-top: 22px;
        padding-top: 12px;
        border-top: 1px solid #e2c1c1;
        button{
            height: 40px;
        }
    }

`